import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { browserLogsConfig, RUMSDKConfig } from './config'

export const initializeDatadogLoggingSDK = (config) => {
  datadogLogs.init(config)
}

export const initializeDatadogRUMSDK = (config) => {
  datadogRum.init(config)
}

export const initializeDatadog = () => {
  if (process.env.REACT_APP_DATADOG_ENABLED) {
    initializeDatadogLoggingSDK(browserLogsConfig)
    initializeDatadogRUMSDK(RUMSDKConfig)
  }
}
